<template>
  <div class='mt-2 mb-3'>
    <h5>Paste-in from spreadsheet</h5>
    <p class='mt-1'>
      To paste directly from Microsoft Excel, follow the layout 'number, first_name, last_name, usual_name, previous_yellow_cards, position' in columns.
      <br />Then, paste the selection in this input field.
    </p>
    <textarea
      type='text'
      placeholder='Paste your spreadsheet selection here'
      @input='inputText'
      :class='{ success }'
    ></textarea>
  </div>
</template>
<script>
export default {
  name: 'SpreadsheetInsert',
  props: ['fields'],
  data () {
    return {
      entries: [],
      success: false
    }
  },
  methods: {
    inputText (e) {
      let data = JSON.parse(JSON.stringify(e.target.value))
      e.target.value = ''
      e.target.disabled = true
      let rows = data.split('\n')
      let entries = []
      for (let y = 0; y < rows.length; y++) {
        let cells = rows[y].split('\t')
        let entry = {}
        let index = 0
        for (let field of this.fields) {
          if (cells[index]) {
            entry[field] = cells[index].trim()
          } else {
            entry[field] = null
          }
          index++
        }
        entries.push(entry)
      }
      this.entries = entries
      this.success = true
      e.target.value = 'Success!'
      setTimeout(() => {
        this.success = false
        e.target.value = ''
        e.target.disabled = false
      }, 600)
      this.$emit('data', this.entries)
    }
  }
}
</script>
<style lang='scss' scoped>
textarea {
  width: 100%;
  height: 45px;
  border: 1px solid rgb(202, 202, 202);
  border-radius: 4px;
  text-align: center;
  line-height: 38px;
  transition: box-shadow 0.4s linear;
  box-shadow: 0px 0px 10px rgba(0, 106, 228, 0) ;
  &.success {
    box-shadow: 0px 0px 10px rgba(0, 106, 228, 1) ;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SpreadsheetInsert.vue